export default __webpack_public_path__ + "static/media/Samosa.ed7b7dcb.jpeg";